import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'gotravlr:passport';
const DEFAULT_ORIGIN = 'IN';

// Visible labels for the selector. Keep in sync with VISA_DATA / EMBASSY_DATA origin keys.
export const COUNTRY_LABELS = {
  IN: 'India',
  US: 'United States',
  GB: 'United Kingdom',
  CA: 'Canada',
  AU: 'Australia',
};

const Ctx = createContext(null);

export function PassportProvider({ children }) {
  const [origin, setOriginState] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || DEFAULT_ORIGIN; } catch { return DEFAULT_ORIGIN; }
  });
  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, origin); } catch { /* ignore */ }
  }, [origin]);

  const setOrigin = (v) => setOriginState((v || DEFAULT_ORIGIN).toString().toUpperCase());

  const value = useMemo(() => ({ origin, setOrigin }), [origin]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function usePassport() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('usePassport must be used inside PassportProvider');
  return ctx;
}
